<template>
  <div>
    <h1>Operator clients</h1>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2>
            <v-icon>search</v-icon>Search the operator clients
          </h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="forename" label="Forename" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="surname" label="Surname" outline />
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn @click="searchClients" :loading="loading">
              <v-icon>search</v-icon>
              <span>&#160;Search</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-data-table
      :pagination.sync="pagination"
      :loading="loading"
      :headers="headers"
      :items="clients"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{name:'operatorClient', params:{id: props.item.client_n}}"
            >{{ props.item.client_n }}</v-btn>
          </td>
          <td>{{ props.item.prefix }}</td>
          <td>{{ props.item.forename }}</td>
          <td>{{ props.item.surname }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "OperatorClients",
  metaInfo() {
    return {
      title: "Operator clients",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      clients: [],
      forename: "",
      surname: "",
      panel: [],
      loading: false,
      headers: [
        {
          text: "Client no",
          value: "client_n"
        },
        {
          text: "Prefix",
          value: "prefix"
        },
        {
          text: "Forename",
          value: "forename"
        },
        {
          text: "Surname",
          value: "surname"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "client_n",
        descending: true
      }
    };
  },
  methods: {
    searchClients() {
      nbmlaw
        .get(`/cors/admin/file/operatorClients`, {
          params: {
            forename: this.forename,
            surname: this.surname
          }
        })
        .then(response => {
          // console.log(response.data);
          this.clients = response.data;
          this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>
